import { useCallback } from 'react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

const PREFIX_NAME = 'gtm.groupon.';

const useGTM = (prefix?: string) => {
  const sendDataToGTM = useGTMDispatch();

  const sendGTM = useCallback((eventName: string, data?: Record<string, any>) => {
    sendDataToGTM({ event: `${prefix ?? PREFIX_NAME}${eventName}`, ...data });
  }, []);

  return sendGTM;
};

export default useGTM;
